import { render, staticRenderFns } from "./CalculadorTutor.vue?vue&type=template&id=61e239ce&scoped=true"
import script from "./CalculadorTutor.vue?vue&type=script&lang=js"
export * from "./CalculadorTutor.vue?vue&type=script&lang=js"
import style0 from "./CalculadorTutor.vue?vue&type=style&index=0&id=61e239ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e239ce",
  null
  
)

export default component.exports